import { ISupplier } from "@/@types/supplier";
import { Badge } from "@/components/ui/badge";
import { ColumnDef } from "@tanstack/react-table";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import { ToggleStatusSwitch } from "./toggle-switch";

export const columns: ColumnDef<ISupplier>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
  },
  {
    accessorKey: "supplier_number",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Número" />
    ),
    cell: ({ row }) => row.original.supplier_number,
  },
  {
    accessorKey: "supplier_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Fornecedor" />
    ),
    cell: ({ row }) => {
      const name = row.original.supplier_name;

      const capitalizeWords = (text: string) =>
        text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

      return capitalizeWords(name);
    },
  },

  {
    accessorKey: "cnpj",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="CNPJ" />
    ),
    cell: ({ row }) => {
      const cnpj = row.original.cnpj;

      const formatCNPJ = (value: string) => {
        return value.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
          "$1.$2.$3/$4-$5"
        );
      };

      return formatCNPJ(cnpj);
    },
  },

  {
    accessorKey: "is_active",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const isActive = row.original.is_active;

      return (
        <Badge
          className={`cursor-default transition-colors ${
            isActive
              ? "bg-green-500 text-white hover:bg-green-600"
              : "bg-red-500 text-white hover:bg-red-600"
          }`}
        >
          {isActive ? "Ativo" : "Inativo"}
        </Badge>
      );
    },
  },

  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Criado Em" />
    ),
    cell: ({ row }) => {
      const dateString = row.getValue("created_at") as string;
      if (!dateString) return "";

      try {
        const parsedDate = parseISO(dateString);
        return format(parsedDate, "dd/MM/yyyy HH:mm:ss", { locale: ptBR });
      } catch (error) {
        return "Data Inválida";
      }
    },
  },
  {
    accessorKey: "updated_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Atualizado Em" />
    ),
    cell: ({ row }) => {
      const dateString = row.getValue("updated_at") as string;
      if (!dateString) return "";

      try {
        const parsedDate = parseISO(dateString);
        return format(parsedDate, "dd/MM/yyyy HH:mm:ss", { locale: ptBR });
      } catch (error) {
        return "Data Inválida";
      }
    },
  },
  {
    id: "actions",
    header: "Ações",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
  {
    id: "toggle",
    header: "Alterar Status",
    cell: ({ row }) => (
      <ToggleStatusSwitch
        id={row.original.id}
        isActive={row.original.is_active}
      />
    ),
  },
];
